import { memo } from 'react';

import { Skeleton } from '@air/component-skeleton';

const PROMPT_CARD_SKELETON_CARD_IDS = ['leading', 'trailing'] as const;

/**
 * Two card-shaped placeholders. The row does not scroll, so the second card is clipped until the
 * real carousel replaces it.
 */
export const WorkspaceAgentPromptCardCarouselSkeleton = memo(() => {
  return (
    <div aria-busy="true" data-testid="WORKSPACE_AGENT_PROMPT_CARD_SKELETON">
      <span className="sr-only">Loading suggestions</span>
      <div className="relative -mx-4 flex gap-2 overflow-hidden px-4">
        {PROMPT_CARD_SKELETON_CARD_IDS.map((id) => (
          <div className="h-40 w-5/6 shrink-0" data-testid="WORKSPACE_AGENT_PROMPT_CARD_SKELETON_CARD" key={id}>
            <Skeleton className="size-full overflow-hidden rounded-12" />
          </div>
        ))}
      </div>
    </div>
  );
});

WorkspaceAgentPromptCardCarouselSkeleton.displayName = 'WorkspaceAgentPromptCardCarouselSkeleton';
